import type {
  QuestionnaireStrategy,
  QuestionnaireSelectionResult,
  SelectionContext,
} from '../types'

/**
 * Strategy: Fallback to default questionnaire
 * Priority: Last (always)
 *
 * Behavior:
 * - Returns 'default' questionnaire as last resort
 * - If Monarch is still loading, waits for it to complete
 * - Should be the last strategy in the chain
 */
export const createFallbackStrategy = (): QuestionnaireStrategy => ({
  name: 'fallback',

  execute: (context: SelectionContext): QuestionnaireSelectionResult => {
    // If Monarch is still loading, don't set a fallback yet - wait for it
    if (context.monarchIsLoading) {
      return {
        questionnaire: null,
        shouldContinue: false,
        reason: 'Waiting for Monarch to complete before using fallback',
      }
    }

    return {
      questionnaire: 'default',
      shouldContinue: false,
      reason: 'Fallback to default questionnaire',
    }
  },

  isEnabled: () => true,
})
